import React from 'react';
import { getRuleOriginLabel } from '../../../constants/violationConstants';

/**
 * Происхождение правила (Part 4, раздел 6.4).
 *
 * Поле `origin` — target addition: пока backend его не отдаёт, бейдж не
 * рисуется. Неизвестный `source` тоже ничего не рисует: показывать
 * технический код источника пользователю незачем.
 */
const RuleOriginBadge = ({ origin }) => {
  const label = getRuleOriginLabel(origin);
  if (!label) return null;

  return <span className="vio-badge vio-badge--origin">{label}</span>;
};

export default RuleOriginBadge;
